import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMinus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path d="M17 10.75a.75.75 0 0 0 0-1.5zM3 9.25a.75.75 0 0 0 0 1.5zm14 0H3v1.5h14z" />
  </svg>
);
export default SvgMinus;
